module.exports = __webpack_public_path__ + "img/ig.1aa08520.svg";